// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"8ea480c4","100":"2ad8cf2c","134":"2a61221b","319":"e12640fc","557":"6c41b954","664":"af4358bd","868":"d5c2409b"}[chunkId] + ".chunk.css";
};